<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedication</a>
</li>
<li id="level1-front5">
<a href="#/front03">Frontispiece</a>
</li>
<li id="c01">
<a href="#/c01">In the Valley of Bones</a>
</li>
<li id="c02">
<a href="#/c02">J. Edgar, Joe, and Me</a>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">State and Church</span>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">The Pope Speaks</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">Joy to My Youth</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">A Religious Education</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">Capers In Chains</span>
</li>
<li id="c001">
<span href="#/c001" title="Link target outside of Sample">Photos</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Holy War</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">The Imposition</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">A Priest Forever</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">The Last Word</span>
</li>
<li id="level1-back18">
<span href="#/back01" title="Link target outside of Sample">Acknowledgments</span>
</li>
<li id="level1-back19">
<span href="#/back02" title="Link target outside of Sample">About the Author</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ff31ff3e